module.exports = __webpack_public_path__ + "3b4856d954f9bd92db9a42c4b3365b38.png";


//////////////////
// WEBPACK FOOTER
// ./application/adminlte/plugins/iCheck/minimal/green.png
// module id = 303
// module chunks = 0